import { DomainBase } from "./DomainBase";

export class Type extends DomainBase {
    constructor() {
        super();
        this.name = "";
    }
}
